var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgZanOn = function SvgZanOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CC0C1C",
    d: "m3.433 4.101 1.242-2.994A1.788 1.788 0 0 1 7.322.303C8.069.803 8 1.645 8 2.547V5.13h2.992c2.013 0 3.458 1.95 2.88 3.887l-1.146 3.832a3.01 3.01 0 0 1-3.13 2.141l-7.758-.649A2.01 2.01 0 0 1 0 12.334V7.337a2.01 2.01 0 0 1 1.675-1.985l.237-.04a2 2 0 0 0 1.521-1.211"
  })));
};
export default SvgZanOn;